import axios from "axios";

export const api = axios.create({
    baseURL: "/",
});

export const apiGeoTag = axios.create({
    baseURL: "/geo",
});

api.interceptors.response.use(
    function (response) {
        console.log(response)
      if (
        !response?.data?.success &&
        response?.data?.message === "Please Login."
      ) {
        window.location.href = "/auth";
      }
      return response;
    },
    function (error) {
      let res = error.response;
     console.log("response", error)
      console.error("Looks like there was a problem. Status Code:" + res.status);
      return Promise.reject(error);
  }
  );

apiGeoTag.interceptors.request.use(config => {
    config.headers['Authorization'] = `${sessionStorage.getItem('token')}`;
    return config;
});


